import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

import modalModule from './modules/modals'
import applicationFormModule from './modules/applicationForm'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    modals: modalModule,
    applicationForm: applicationFormModule
  }
})
